/**
 * MAYGLOW LUXURY AYURVEDIC THEME — CORE INTERACTIVE ENGINE
 * Production-ready Shopify Storefront JS with Emil Kowalski Physics
 */

(function () {
  'use strict';

  /* ==========================================================================
     1. PRODUCT DATABASE (Authentic MayGlow Products & High-Res Assets)
     ========================================================================== */
  const MAYGLOW_PRODUCTS = {
    'face-serum': {
      id: 'face-serum',
      title: 'Vitamin C Radiant Face Serum',
      subtitle: '20% Bio-Vitamin C + Hyaluronic Acid & Sacred Saffron',
      category: 'Face Care',
      price: 499,
      comparePrice: 599,
      rating: '4.9',
      reviewCount: '184',
      badge: 'Best Seller',
      volume: '30 ml / 1.0 fl. oz.',
      description: 'An ultra-potent restorative elixir combining 20% stabilized Vitamin C (3-O-Ethyl Ascorbic Acid), Kumkumadi Tailam, botanical Ferulic Acid, and triple molecular Hyaluronic Acid. Penetrates deep dermal layers to banish hyperpigmentation, brighten uneven skin tone, boost collagen synthesis, and restore radiant glass skin.',
      highlights: [
        'Fades Sunspots & Hyperpigmentation',
        'Stimulates Pro-Collagen Synthesis & Elasticity',
        'Delivers 48-Hour Micro-Hydration Barrier',
        'Neutralizes Urban Pollution & Free Radicals'
      ],
      ingredients: '20% Vitamin C (3-O-Ethyl Ascorbic Acid), Kumkumadi Tailam, Ferulic Acid, Botanical Hyaluronic Acid, Gotu Kola (Centella Asiatica) Extract, Licorice Root Extract, Niacinamide, Pure Aloe Barbadensis Leaf Juice, Tocopherol (Vitamin E).',
      howToUse: 'After cleansing with MayGlow Face Wash, dispense 3-4 drops onto clean fingertips. Gently press and massage upward over face, neck, and décolletage until fully absorbed. Follow with moisturizer and daytime SPF.',
      images: [
        'face-serum-main.jpg',
        'gallery-face-serum-watermark-removed-vitamin-c.jpeg',
        'gallery-face-serum-watermark-removed-vitammin-c.jpeg',
        'gallery-face-serum-box.png'
      ]
    },
    'vit-c-face-wash': {
      id: 'vit-c-face-wash',
      title: 'Vitamin C Brightening Face Wash',
      subtitle: 'Papaya Fruit Enzymes, Sweet Orange & Vitamin C',
      category: 'Face Care',
      price: 399,
      comparePrice: 499,
      rating: '4.9',
      reviewCount: '142',
      badge: 'Award Winner',
      volume: '100 ml / 3.4 fl. oz.',
      description: 'A revitalizing gel cleanser enriched with Papaya fruit enzymes, Sweet Orange peel hydrosol, and antioxidant Vitamin C. Gently dissolves dirt, excess sebum, and micro-pollutants while preserving the natural skin barrier for an illuminated, refreshed complexion.',
      highlights: [
        'Gently Micro-Exfoliates Dead Surface Cells',
        'Imparts Instant Citrus Luminosity & Glow',
        'Gentle Non-Stripping, pH-Balanced Lather',
        'Purifies Congested Pores & Combats Dullness'
      ],
      ingredients: 'Papaya (Carica Papaya) Fruit Extract, Sweet Orange (Citrus Sinensis) Peel Extract, 3-O-Ethyl Ascorbic Acid (Vitamin C), Turmeric Root Extract, Botanical Glycerin, Aloe Vera Juice, Pro-Vitamin B5, Coco-Glucoside.',
      howToUse: 'Apply a coin-sized amount onto damp face. Massage gently in upward circular motions for 60 seconds, creating a rich silky lather. Rinse thoroughly with cool water and pat dry.',
      images: [
        'vitamin-c-face-wash-main.jpg',
        'gallery-vitamin-c-face-wash-papaya-face-wash-on-stone-202608231544.jpeg',
        'gallery-vitamin-c-face-wash-papaya-face-wash-tube-displayed-202608231545.jpeg',
        'gallery-vit-c-face-wash-label.png'
      ]
    },
    'miller-face-wash': {
      id: 'miller-face-wash',
      title: 'Miller Neem & Aloe Vera Face Wash',
      subtitle: 'Organic Wild Neem, Cold-Pressed Aloe & Tea Tree',
      category: 'Face Care',
      price: 199,
      comparePrice: 249,
      rating: '4.8',
      reviewCount: '96',
      badge: 'Acne Defense',
      volume: '100 ml / 3.4 fl. oz.',
      description: 'Formulated with potent wild-harvested Neem leaves, soothing organic Aloe Vera pulp, and Tea Tree oil. Effectively eliminates acne-causing bacteria, balances sebum secretion, and calms irritated, inflamed skin without stripping essential moisture.',
      highlights: [
        'Targeted Clarifying Defense Against Breakouts',
        'Soothes Skin Inflammation & Active Redness',
        'Regulates Sebum for All-Day Matte Freshness',
        'Deep Pore Purifying Without Moisture Loss'
      ],
      ingredients: 'Wild Neem (Azadirachta Indica) Leaf Extract, Organic Aloe Barbadensis Leaf Juice, Tea Tree Essential Oil, Holy Basil (Tulsi) Extract, Green Tea Extract, Salicylic Acid (0.5%), Allantoin, Botanical Glycerin.',
      howToUse: 'Lather a small amount between wet palms. Gently massage over face, concentrating on T-zone and breakout-prone areas. Rinse with lukewarm water. Use morning and night.',
      images: [
        'miller-face-wash-main.jpg',
        'gallery-miller-face-wash-face-wash-bottle-on-tray-202608231549.jpeg',
        'gallery-miller-face-wash-water-splashing-face-wash-bottle-202608231519.jpeg',
        'gallery-miller-face-wash-label.png'
      ]
    },
    'hair-fall-shampoo': {
      id: 'hair-fall-shampoo',
      title: 'Hair Fall Control Shampoo',
      subtitle: 'Bhringraj, Red Onion Seed & Wild Amla Decoction',
      category: 'Hair Care',
      price: 349,
      comparePrice: 449,
      rating: '4.9',
      reviewCount: '210',
      badge: 'Ayurvedic Gold',
      volume: '200 ml / 6.7 fl. oz.',
      description: 'A trichology-backed Ayurvedic decoction steeped with Bhringraj (the King of Hair), sulfur-rich Red Onion Seed oil, Shikakai, and Wild Indian Gooseberry (Amla). Strengthens follicles from root to tip, drastically curtails hair breakage, and stimulates dense follicular regrowth.',
      highlights: [
        'Fortifies Roots to Combat Hair Fall & Breakage',
        'Strengthens Root Bulb Anchoring & Follicles',
        'Restores Natural Bounce, Density & Gloss',
        'Sulfate-Free & Gentle on Color-Treated Hair'
      ],
      ingredients: 'Bhringraj (Eclipta Alba) Extract, Red Onion (Allium Cepa) Seed Oil, Amla (Phyllanthus Emblica) Extract, Shikakai (Acacia Concinna), Reetha, Brahmi Extract, Plant Hydrolyzed Keratin, Biotin.',
      howToUse: 'Apply to wet scalp and hair. Massage gently with fingertips into a rich herbal lather, allowing botanicals to absorb for 2-3 minutes. Rinse thoroughly. Follow with MayGlow Botanical Conditioner.',
      images: [
        'hair-fall-shampoo-main.jpg',
        'gallery-hair-fall-shampoo-blue-shampoo-bottle-on-shelf-202608231534.jpeg',
        'gallery-hair-fall-shampoo-shampoo-bottle-near-towel-candle-202608231536.jpeg',
        'gallery-hair-fall-shampoo-label.png'
      ]
    },
    'dandruff-shampoo': {
      id: 'dandruff-shampoo',
      title: 'Anti-Dandruff Clarifying Shampoo',
      subtitle: 'Australian Tea Tree Oil, Reetha & Rosemary Extract',
      category: 'Hair Care',
      price: 349,
      comparePrice: 449,
      rating: '4.9',
      reviewCount: '118',
      badge: 'Scalp Clarifying',
      volume: '200 ml / 6.7 fl. oz.',
      description: 'A therapeutic botanical cleanser combining high-potency Tea Tree oil, Rosemary hydrosol, and Fenugreek seed extract. Gently removes stubborn dandruff flakes, soothes persistent scalp itchiness, and restores healthy scalp microbial harmony.',
      highlights: [
        'Targeted Scalp Flake & Itch Defense',
        'Calms Scalp Itching, Irritation & Flaking',
        'Rebalances Scalp Sebum & Microbiome',
        'Leaves Hair Light, Fresh & Naturally Voluminous'
      ],
      ingredients: 'Pure Tea Tree (Melaleuca Alternifolia) Oil, Rosemary Leaf Extract, Fenugreek (Methi) Extract, Reetha (Soapnut), Neem Extract, Salicylic Acid, Zinc Pyrithione (1%), Peppermint Oil.',
      howToUse: 'Wet hair and apply liberally to scalp. Massage thoroughly in circular motions for 2-3 minutes. Rinse well with warm water. Use 2-3 times per week for optimal scalp clarity.',
      images: [
        'dandruff-shampoo-main.jpg',
        'gallery-dandruff-shampoo-dandruff-shampoo-bottle-on-sink-202608231552.jpeg',
        'gallery-dandruff-shampoo-shampoo-bottle-on-shelf-2k-202608231551.jpeg',
        'gallery-dandruff-shampoo-label.png'
      ]
    },
    'hair-conditioner': {
      id: 'hair-conditioner',
      title: 'Nourishing Botanical Hair Conditioner',
      subtitle: 'Moroccan Argan Oil, Hibiscus Flower & Tocopherol',
      category: 'Hair Care',
      price: 399,
      comparePrice: 499,
      rating: '4.8',
      reviewCount: '164',
      badge: 'Deep Hydra',
      volume: '200 ml / 6.7 fl. oz.',
      description: 'An intensely hydrating botanical conditioner crafted with cold-pressed Moroccan Argan oil, Hibiscus petals, Hydrolyzed Silk protein, and Vitamin E. Instantly smooths cuticles, eliminates frizz, and seals moisture into dry or chemically treated strands.',
      highlights: [
        'Weightless Silken Slip & Tangle-Free Combing',
        'Restores Elasticity & Repairs Split Strands',
        'Thermal Shield Against Blow-Dry Heat & UV',
        'Envelops Strands in Reflective Glass Shine'
      ],
      ingredients: 'Moroccan Argan (Argania Spinosa) Kernel Oil, Hibiscus Sabdariffa Extract, Hydrolyzed Silk Protein, Shea Butter, Tocopheryl Acetate (Vitamin E), Cetearyl Alcohol, D-Panthenol.',
      howToUse: 'After shampooing, apply generously to mid-lengths and ends of hair. Leave on for 2-5 minutes to allow botanicals to nourish. Rinse thoroughly with cool water.',
      images: [
        'hair-conditioner-main.jpg',
        'gallery-hair-conditioner-cyan-hair-conditioner-on-countertop-202608231558.jpeg',
        'gallery-hair-conditioner-cyan-hair-conditioner-on-stool-202608231558.jpeg',
        'gallery-hair-conditioner-label.png'
      ]
    },
    'hair-serum': {
      id: 'hair-serum',
      title: 'Silken Anti-Frizz Botanical Hair Serum',
      subtitle: 'Cold-Pressed Walnut Oil, Sweet Almond & Vitamin E',
      category: 'Hair Care',
      price: 499,
      comparePrice: 599,
      rating: '4.9',
      reviewCount: '155',
      badge: 'Gloss Finish',
      volume: '50 ml / 1.7 fl. oz.',
      description: 'A weightless, non-greasy leave-in shine serum packed with pure Walnut oil, Sweet Almond oil, Rosehip seed lipids, and Tocopherol Vitamin E. Instantly tames stubborn frizz, shields against thermal heat styling up to 230°C, and delivers mirrors-edge reflective shine.',
      highlights: [
        '72-Hour Anti-Frizz Humidity Shield',
        'Featherweight Non-Sticky Liquid Silk Finish',
        'Thermal Heat Protection up to 230°C',
        'Seals Split Ends with Mirror-Like Reflectivity'
      ],
      ingredients: 'Cold-Pressed Walnut (Juglans Regia) Oil, Sweet Almond (Prunus Amygdalus Dulcis) Oil, Rosehip Seed Oil, Cyclopentasiloxane & Dimethiconol, Vitamin E Acetate, Natural Botanical Fragrance.',
      howToUse: 'Dispense 2-3 drops into palms. Rub hands together and distribute evenly through towel-dried or dry hair from mid-lengths to ends. Style as desired.',
      images: [
        'hair-serum-main.jpg',
        'gallery-hair-serum-hair-serum-on-glass-tray-202608231554.jpeg',
        'gallery-hair-serum-hair-serum-on-vanity-table-202608231557.jpeg',
        'gallery-hair-serum-box.png'
      ]
    },
    'body-wash': {
      id: 'body-wash',
      title: 'Botanical Moisturizing Body Wash',
      subtitle: 'Kashmiri Saffron, Indian Sandalwood & Mogra Hydrosol',
      category: 'Body Care',
      price: 349,
      comparePrice: 429,
      rating: '4.9',
      reviewCount: '124',
      badge: 'Sensorial Bath',
      volume: '250 ml / 8.4 fl. oz.',
      description: 'An indulgent, aromatherapeutic shower nectar crafted with authentic Kashmiri Saffron, Mysore Sandalwood extract, and fresh Mogra flower hydrosol. Transforms into a cushion of velvety lather that deeply purifies while pampering your skin with lasting moisture.',
      highlights: [
        'Sumptuous Aromatherapeutic Calming Bath',
        'Sulfate-Free Lather Preserves Natural Barrier',
        'Deeply Conditions & Nourishes Parched Skin',
        'Leaves an Alluring Ayurvedic Fragrance Trail'
      ],
      ingredients: 'Kashmiri Saffron (Crocus Sativus) Extract, Mysore Sandalwood (Santalum Album) Extract, Mogra Flower Hydrosol, Shea Butter Glycerides, Vitamin E, Decyl Glucoside, Sodium Cocoyl Isethionate.',
      howToUse: 'Pour a generous amount onto a loofah or wet palms. Work into a creamy, fragrant lather over damp skin. Inhale the soothing botanical aromatics and rinse clean with warm water.',
      images: [
        'body-wash-main.jpg',
        'gallery-body-wash-watermark-removed-shhowergel.jpeg',
        'gallery-body-wash-watermark-removed-showergel.jpeg',
        'gallery-body-wash-label.png'
      ]
    },
    'body-lotion': {
      id: 'body-lotion',
      title: 'Sensorial Botanical Body Perfume Lotion',
      subtitle: 'Sacred Lotus, Organic Coconut Milk & Shea Butter',
      category: 'Body Care',
      price: 299,
      comparePrice: 379,
      rating: '4.8',
      reviewCount: '98',
      badge: '24h Hydra',
      volume: '200 ml / 6.7 fl. oz.',
      description: 'A silken, fast-absorbing body lotion infused with Sacred Indian Lotus nectar, fresh Coconut milk, and African Shea butter. Melts instantly upon contact to provide 24-hour non-greasy cellular hydration while enveloping the body in an exquisite sensual perfume trail.',
      highlights: [
        '24-Hour Continuous Moisture Lock',
        'Ultra-Lightweight, Fast Absorbing, Zero Greasiness',
        'Enhances Natural Skin Radiance & Softness',
        'Exquisite Long-Lasting Blooming Lotus Perfume'
      ],
      ingredients: 'Sacred Lotus (Nelumbo Nucifera) Flower Extract, Organic Coconut (Cocos Nucifera) Milk, Pure Shea Butter, Sweet Almond Oil, Niacinamide, Vitamin E, Allantoin, Botanical Glycerin.',
      howToUse: 'Smooth generously all over body after bathing or whenever skin feels dry. Gently massage in circular strokes until absorbed, paying special attention to elbows, knees, and dry patches.',
      images: [
        'body-perfume-lotion-main.jpg',
        'gallery-body-perfume-lotion-lotion-bottle-on-bedside-table-202608231541.jpeg',
        'gallery-body-perfume-lotion-turquoise-lotion-bottle-on-vanity-202608231539.jpeg',
        'gallery-body-lotion-label.png'
      ]
    }
  };

  /* Helper to resolve image paths whether in Shopify or local */
  function getAssetUrl(filename) {
    if (filename.startsWith('http') || filename.startsWith('/') || filename.startsWith('assets/')) {
      return filename;
    }
    return 'assets/' + filename;
  }

  /* ==========================================================================
     2. SHOPPING CART STATE MANAGEMENT
     ========================================================================== */
  const Cart = {
    items: [],
    FREE_SHIPPING_THRESHOLD: 799,

    init: function () {
      try {
        const saved = localStorage.getItem('mayglow_cart');
        if (saved) {
          this.items = JSON.parse(saved);
        }
      } catch (e) {
        this.items = [];
      }
      this.render();
      this.bindEvents();
    },

    save: function () {
      try {
        localStorage.setItem('mayglow_cart', JSON.stringify(this.items));
      } catch (e) {}
      this.render();
    },

    addItem: function (item) {
      const existing = this.items.find(i => i.id === item.id);
      if (existing) {
        existing.qty += (item.qty || 1);
      } else {
        this.items.push({
          id: item.id,
          title: item.title,
          price: Number(item.price),
          image: item.image,
          qty: item.qty || 1
        });
      }
      this.save();
      this.open();
      this.showToast(`Added ${item.title} to your ritual`);
    },

    updateQty: function (id, delta) {
      const item = this.items.find(i => i.id === id);
      if (item) {
        item.qty += delta;
        if (item.qty <= 0) {
          this.items = this.items.filter(i => i.id !== id);
        }
        this.save();
      }
    },

    removeItem: function (id) {
      this.items = this.items.filter(i => i.id !== id);
      this.save();
    },

    getTotal: function () {
      return this.items.reduce((sum, item) => sum + (item.price * item.qty), 0);
    },

    getCount: function () {
      return this.items.reduce((sum, item) => sum + item.qty, 0);
    },

    render: function () {
      const count = this.getCount();
      const total = this.getTotal();

      // Update Header & Drawer Badge Counts
      const headerCount = document.getElementById('header-cart-count');
      const drawerCount = document.getElementById('cart-drawer-count');
      if (headerCount) headerCount.textContent = count;
      if (drawerCount) drawerCount.textContent = `${count} ${count === 1 ? 'item' : 'items'}`;

      // Update Free Shipping Progress Bar
      const shippingMsg = document.getElementById('free-shipping-message');
      const shippingBar = document.getElementById('free-shipping-progress');
      if (shippingMsg && shippingBar) {
        if (total >= this.FREE_SHIPPING_THRESHOLD) {
          shippingMsg.innerHTML = '🎉 You have unlocked <strong>Complimentary Express Shipping!</strong>';
          shippingBar.style.width = '100%';
        } else {
          const remaining = this.FREE_SHIPPING_THRESHOLD - total;
          const percentage = Math.min(100, (total / this.FREE_SHIPPING_THRESHOLD) * 100);
          shippingMsg.innerHTML = `Add <strong>₹${remaining}</strong> more to unlock <strong>Complimentary Express Shipping</strong>`;
          shippingBar.style.width = `${percentage}%`;
        }
      }

      // Render Line Items
      const itemsContainer = document.getElementById('cart-drawer-items');
      const emptyState = document.getElementById('cart-empty-state');
      const subtotalEl = document.getElementById('cart-drawer-subtotal');
      const shippingStatusEl = document.getElementById('cart-drawer-shipping-status');

      if (subtotalEl) subtotalEl.textContent = `₹${total}`;
      if (shippingStatusEl) {
        shippingStatusEl.textContent = total >= this.FREE_SHIPPING_THRESHOLD ? 'FREE' : 'Calculated at checkout';
      }

      if (itemsContainer) {
        if (this.items.length === 0) {
          if (emptyState) emptyState.style.display = 'block';
          // Clean dynamic item nodes
          const dynamicItems = itemsContainer.querySelectorAll('.cart-item');
          dynamicItems.forEach(node => node.remove());
        } else {
          if (emptyState) emptyState.style.display = 'none';
          const dynamicItems = itemsContainer.querySelectorAll('.cart-item');
          dynamicItems.forEach(node => node.remove());

          this.items.forEach(item => {
            const el = document.createElement('div');
            el.className = 'cart-item';
            el.innerHTML = `
              <img src="${item.image}" alt="${item.title}" class="cart-item__img" width="75" height="75">
              <div class="cart-item__details">
                <h4 class="cart-item__title">${item.title}</h4>
                <div class="cart-item__price">₹${item.price}</div>
                <div class="cart-item__controls">
                  <div class="cart-item__qty">
                    <button type="button" data-action="cart-dec" data-id="${item.id}" aria-label="Decrease quantity">−</button>
                    <span>${item.qty}</span>
                    <button type="button" data-action="cart-inc" data-id="${item.id}" aria-label="Increase quantity">+</button>
                  </div>
                  <button type="button" class="cart-item__remove" data-action="cart-remove" data-id="${item.id}">Remove</button>
                </div>
              </div>
            `;
            itemsContainer.appendChild(el);
          });
        }
      }
    },

    open: function () {
      const drawer = document.getElementById('cart-drawer');
      if (drawer) {
        drawer.classList.add('open');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
    },

    close: function () {
      const drawer = document.getElementById('cart-drawer');
      if (drawer) {
        drawer.classList.remove('open');
        drawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    },

    showToast: function (message) {
      let toast = document.getElementById('theme-toast');
      if (!toast) {
        toast = document.createElement('div');
        toast.id = 'theme-toast';
        toast.style.cssText = `
          position: fixed;
          bottom: 24px;
          left: 50%;
          transform: translateX(-50%) translateY(20px);
          background: var(--c-primary);
          color: var(--c-bg);
          padding: 0.75rem 1.5rem;
          border-radius: var(--radius-sm);
          font-size: 0.85rem;
          font-weight: 500;
          box-shadow: var(--shadow-lg);
          z-index: 2000;
          opacity: 0;
          transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
          pointer-events: none;
        `;
        document.body.appendChild(toast);
      }
      toast.textContent = message;
      toast.style.opacity = '1';
      toast.style.transform = 'translateX(-50%) translateY(0)';

      setTimeout(() => {
        toast.style.opacity = '0';
        toast.style.transform = 'translateX(-50%) translateY(20px)';
      }, 3000);
    },

    bindEvents: function () {
      document.addEventListener('click', e => {
        const target = e.target.closest('[data-action]');
        if (!target) return;

        const action = target.getAttribute('data-action');

        if (action === 'open-cart') {
          e.preventDefault();
          this.open();
        } else if (action === 'close-cart') {
          e.preventDefault();
          this.close();
        } else if (action === 'cart-inc') {
          const id = target.getAttribute('data-id');
          this.updateQty(id, 1);
        } else if (action === 'cart-dec') {
          const id = target.getAttribute('data-id');
          this.updateQty(id, -1);
        } else if (action === 'cart-remove') {
          const id = target.getAttribute('data-id');
          this.removeItem(id);
        } else if (action === 'add-to-cart') {
          e.preventDefault();
          const id = target.getAttribute('data-product-id');
          QuickView.open(id);
        } else if (action === 'add-bundle') {
          e.preventDefault();
          const id = target.getAttribute('data-bundle-id');
          const title = target.getAttribute('data-title');
          const price = target.getAttribute('data-price');
          const image = target.getAttribute('data-image');
          this.addItem({ id, title, price, image, qty: 1 });
        }
      });

      // Checkout Button -> Trigger Online Delivery Coming Soon Modal
      const checkoutBtn = document.getElementById('cart-checkout-btn');
      if (checkoutBtn) {
        checkoutBtn.addEventListener('click', (e) => {
          e.preventDefault();
          DeliveryNotice.open();
        });
      }
    }
  };

  /* ==========================================================================
     3. HERO PRODUCT ROTATOR (4.5s with Emil Kowalski Easing)
     ========================================================================== */
  const HeroRotator = {
    currentSlide: 0,
    interval: null,
    slides: [],
    dots: [],

    init: function () {
      this.slides = document.querySelectorAll('#hero-product-rotator .rotator-slide');
      this.dots = document.querySelectorAll('.rotator-controls .rotator-dot');

      if (this.slides.length === 0) return;

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          this.goTo(index);
          this.restartTimer();
        });
      });

      const rotatorBox = document.getElementById('hero-product-rotator');
      if (rotatorBox) {
        rotatorBox.addEventListener('mouseenter', () => this.stopTimer());
        rotatorBox.addEventListener('mouseleave', () => this.startTimer());
      }

      this.startTimer();
    },

    goTo: function (index) {
      this.slides.forEach(s => s.classList.remove('active'));
      this.dots.forEach(d => d.classList.remove('active'));

      this.currentSlide = (index + this.slides.length) % this.slides.length;

      this.slides[this.currentSlide].classList.add('active');
      if (this.dots[this.currentSlide]) {
        this.dots[this.currentSlide].classList.add('active');
      }
    },

    next: function () {
      this.goTo(this.currentSlide + 1);
    },

    startTimer: function () {
      this.stopTimer();
      this.interval = setInterval(() => this.next(), 4500);
    },

    stopTimer: function () {
      if (this.interval) clearInterval(this.interval);
    },

    restartTimer: function () {
      this.startTimer();
    }
  };

  /* ==========================================================================
     4. RITUAL BUNDLES CAROUSEL
     ========================================================================== */
  const BundlesCarousel = {
    currentIndex: 0,
    track: null,
    dots: [],
    total: 3,
    interval: null,
    isTransitioning: false,

    init: function () {
      this.track = document.getElementById('bundles-track');
      this.dots = document.querySelectorAll('#bundles-dots .bundle-dot');
      const prevBtn = document.getElementById('bundle-prev');
      const nextBtn = document.getElementById('bundle-next');

      if (!this.track) return;

      // Clone first and last slides for infinite scroll illusion
      const firstClone = this.track.children[0].cloneNode(true);
      const lastClone = this.track.children[this.total - 1].cloneNode(true);
      
      this.track.appendChild(firstClone);
      this.track.insertBefore(lastClone, this.track.children[0]);
      
      // Start at real first slide (index 1 in the new track)
      this.currentIndex = 1;
      this.track.style.transition = 'none';
      this.track.style.transform = `translateX(-100%)`;

      if (prevBtn) {
        prevBtn.addEventListener('click', () => { this.goTo(this.currentIndex - 1); this.resetTimer(); });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', () => { this.goTo(this.currentIndex + 1); this.resetTimer(); });
      }

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => { this.goTo(index + 1); this.resetTimer(); });
      });

      this.track.addEventListener('transitionend', () => {
        this.isTransitioning = false;
        if (this.currentIndex === this.total + 1) { // Reached first clone
          this.track.style.transition = 'none';
          this.currentIndex = 1;
          this.track.style.transform = `translateX(-100%)`;
        }
        if (this.currentIndex === 0) { // Reached last clone
          this.track.style.transition = 'none';
          this.currentIndex = this.total;
          this.track.style.transform = `translateX(-${this.total * 100}%)`;
        }
      });

      // Touch & Swipe gestures
      let touchStartX = 0;
      let touchEndX = 0;
      const wrapper = document.getElementById('bundles-carousel-wrapper');
      if (wrapper) {
        wrapper.addEventListener('touchstart', e => {
          touchStartX = e.changedTouches[0].screenX;
        }, { passive: true });

        wrapper.addEventListener('touchend', e => {
          touchEndX = e.changedTouches[0].screenX;
          if (touchStartX - touchEndX > 50) { this.goTo(this.currentIndex + 1); this.resetTimer(); }
          if (touchEndX - touchStartX > 50) { this.goTo(this.currentIndex - 1); this.resetTimer(); }
        }, { passive: true });

        // Pause on hover
        wrapper.addEventListener('mouseenter', () => this.stopTimer());
        wrapper.addEventListener('mouseleave', () => this.startTimer());
      }

      this.startTimer();
    },

    goTo: function (index) {
      if (this.isTransitioning) return;
      this.isTransitioning = true;
      this.currentIndex = index;
      
      if (this.track) {
        this.track.style.transition = 'transform var(--transition-slow)';
        this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;
      }
      
      // Update dots based on real index
      let dotIndex = this.currentIndex - 1;
      if (this.currentIndex === this.total + 1) dotIndex = 0;
      if (this.currentIndex === 0) dotIndex = this.total - 1;
      
      this.dots.forEach((d, i) => {
        d.classList.toggle('active', i === dotIndex);
      });
    },

    startTimer: function() {
      this.stopTimer();
      this.interval = setInterval(() => {
        this.goTo(this.currentIndex + 1);
      }, 4000);
    },

    stopTimer: function() {
      if (this.interval) clearInterval(this.interval);
    },

    resetTimer: function() {
      this.startTimer();
    }
  };

  /* ==========================================================================
     5. CATEGORY FILTER TABS
     ========================================================================== */
  const FilterTabs = {
    init: function () {
      const tabs = document.querySelectorAll('.collection-tabs .tab-btn');
      const products = document.querySelectorAll('#products-grid .product-card');

      if (tabs.length === 0 || products.length === 0) return;

      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          tabs.forEach(t => {
            t.classList.remove('active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('active');
          tab.setAttribute('aria-selected', 'true');

          const cat = tab.getAttribute('data-category');

          products.forEach(product => {
            const prodCat = product.getAttribute('data-category');
            if (cat === 'all' || prodCat === cat) {
              product.style.display = 'flex';
              product.style.opacity = '0';
              product.style.transform = 'translateY(8px)';
              setTimeout(() => {
                product.style.transition = 'opacity 0.3s cubic-bezier(0.16, 1, 0.3, 1), transform 0.3s cubic-bezier(0.16, 1, 0.3, 1)';
                product.style.opacity = '1';
                product.style.transform = 'translateY(0)';
              }, 20);
            } else {
              product.style.display = 'none';
            }
          });
        });
      });
    }
  };

  /* ==========================================================================
     6. QUICK VIEW DOSSIER MODAL
     ========================================================================== */
  const QuickView = {
    activeProduct: null,
    currentQty: 1,
    currentImgIdx: 0,
    touchStartX: 0,
    touchStartY: 0,
    touchEndX: 0,
    touchEndY: 0,

    init: function () {
      // Delegate Quick View trigger clicks
      document.addEventListener('click', e => {
        const target = e.target.closest('[data-action="quick-view"]');
        if (!target) return;
        e.preventDefault();
        const id = target.getAttribute('data-product-id');
        this.open(id);
      });

      // Close modal on click
      document.addEventListener('click', e => {
        const target = e.target.closest('[data-action="close-modal"]');
        if (target) {
          e.preventDefault();
          this.close();
        }
      });

      // Close modal on Escape key & arrow keys for image navigation
      document.addEventListener('keydown', e => {
        const modal = document.getElementById('quick-view-modal');
        if (modal && modal.classList.contains('open')) {
          if (e.key === 'Escape') {
            this.close();
          } else if (e.key === 'ArrowRight') {
            this.nextImage();
          } else if (e.key === 'ArrowLeft') {
            this.prevImage();
          }
        }
      });

      // Gallery Navigation Arrows
      const prevBtn = document.getElementById('qv-prev-img');
      const nextBtn = document.getElementById('qv-next-img');
      if (prevBtn) {
        prevBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.prevImage();
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.nextImage();
        });
      }

      // Touch Swipe Gesture on Mobile
      const imgWrap = document.getElementById('qv-main-image-wrap');
      if (imgWrap) {
        imgWrap.addEventListener('touchstart', e => {
          if (e.changedTouches && e.changedTouches[0]) {
            this.touchStartX = e.changedTouches[0].screenX;
            this.touchStartY = e.changedTouches[0].screenY;
          }
        }, { passive: true });

        imgWrap.addEventListener('touchend', e => {
          if (e.changedTouches && e.changedTouches[0]) {
            this.touchEndX = e.changedTouches[0].screenX;
            this.touchEndY = e.changedTouches[0].screenY;
            this.handleSwipe();
          }
        }, { passive: true });
      }

      // Quantity Pickers
      document.addEventListener('click', e => {
        const target = e.target.closest('[data-action="qv-qty-inc"]');
        if (target) {
          this.currentQty++;
          this.updateQtyDisplay();
        }
      });

      document.addEventListener('click', e => {
        const target = e.target.closest('[data-action="qv-qty-dec"]');
        if (target) {
          if (this.currentQty > 1) {
            this.currentQty--;
            this.updateQtyDisplay();
          }
        }
      });

      // Add to Bag from Quick View
      const submitBtn = document.getElementById('qv-submit-btn');
      if (submitBtn) {
        submitBtn.addEventListener('click', () => {
          if (!this.activeProduct) return;
          Cart.addItem({
            id: this.activeProduct.id,
            title: this.activeProduct.title,
            price: this.activeProduct.price,
            image: getAssetUrl(this.activeProduct.images[0]),
            qty: this.currentQty
          });
          this.close();
        });
      }

      // Add to Collection from Quick View
      const collectionBtn = document.getElementById('qv-collection-btn');
      if (collectionBtn) {
        collectionBtn.addEventListener('click', () => {
          if (!this.activeProduct) return;
          Cart.showToast(`✨ ${this.activeProduct.title} added to your Sacred Ritual Collection!`);
          collectionBtn.classList.add('saved');
          setTimeout(() => collectionBtn.classList.remove('saved'), 2000);
        });
      }
    },

    handleSwipe: function () {
      const diffX = this.touchEndX - this.touchStartX;
      const diffY = this.touchEndY - this.touchStartY;
      if (Math.abs(diffX) > 30 && Math.abs(diffX) > Math.abs(diffY)) {
        if (diffX < 0) {
          this.nextImage(); // Swiped Left -> Next
        } else {
          this.prevImage(); // Swiped Right -> Prev
        }
      }
    },

    setImage: function (idx) {
      if (!this.activeProduct || !this.activeProduct.images || !this.activeProduct.images.length) return;
      this.currentImgIdx = (idx + this.activeProduct.images.length) % this.activeProduct.images.length;
      const mainImg = document.getElementById('qv-main-image');
      const counter = document.getElementById('qv-image-counter');
      const thumbs = document.querySelectorAll('#qv-thumbnails-container .qv-thumb-btn');
      const dots = document.querySelectorAll('#qv-dots-container .qv-dot');

      if (mainImg) {
        mainImg.style.opacity = '0';
        mainImg.style.transform = 'scale(0.98)';
        setTimeout(() => {
          mainImg.src = getAssetUrl(this.activeProduct.images[this.currentImgIdx]);
          mainImg.style.opacity = '1';
          mainImg.style.transform = 'scale(1)';
        }, 120);
      }

      if (counter) {
        counter.textContent = `${this.currentImgIdx + 1} / ${this.activeProduct.images.length}`;
      }

      thumbs.forEach((t, i) => {
        if (i === this.currentImgIdx) {
          t.classList.add('active');
        } else {
          t.classList.remove('active');
        }
      });

      dots.forEach((d, i) => {
        if (i === this.currentImgIdx) {
          d.classList.add('active');
        } else {
          d.classList.remove('active');
        }
      });
    },

    nextImage: function () {
      if (!this.activeProduct || this.activeProduct.images.length <= 1) return;
      this.setImage(this.currentImgIdx + 1);
    },

    prevImage: function () {
      if (!this.activeProduct || this.activeProduct.images.length <= 1) return;
      this.setImage(this.currentImgIdx - 1);
    },

    updateQtyDisplay: function () {
      const input = document.getElementById('qv-qty-input');
      if (input) input.value = this.currentQty;
    },

    open: function (productId) {
      const product = MAYGLOW_PRODUCTS[productId];
      if (!product) return;

      this.activeProduct = product;
      this.currentQty = 1;
      this.currentImgIdx = 0;

      // Populate DOM elements
      const mainImg = document.getElementById('qv-main-image');
      const badge = document.getElementById('qv-badge');
      const category = document.getElementById('qv-category');
      const volume = document.getElementById('qv-volume');
      const title = document.getElementById('qv-title');
      const rating = document.getElementById('qv-rating');
      const reviews = document.getElementById('qv-reviews');
      const price = document.getElementById('qv-price');
      const comparePrice = document.getElementById('qv-compare-price');
      const savings = document.getElementById('qv-savings');
      const desc = document.getElementById('qv-description');
      const highlightsEl = document.getElementById('qv-highlights');
      const ingredientsEl = document.getElementById('qv-ingredients-text');
      const usageEl = document.getElementById('qv-usage-text');
      const thumbsContainer = document.getElementById('qv-thumbnails-container');
      const dotsContainer = document.getElementById('qv-dots-container');
      const counter = document.getElementById('qv-image-counter');

      if (mainImg) mainImg.src = getAssetUrl(product.images[0]);
      if (badge) badge.textContent = product.badge || 'Ayurvedic Heritage';
      if (category) category.textContent = product.category;
      if (volume) volume.textContent = product.volume || '';
      if (title) title.textContent = product.title;
      if (rating) rating.textContent = product.rating;
      if (reviews) reviews.textContent = `(${product.reviewCount} verified reviews)`;
      if (price) price.textContent = `₹${product.price}`;
      if (counter) counter.textContent = `1 / ${product.images.length}`;

      if (comparePrice) {
        if (product.comparePrice > product.price) {
          comparePrice.textContent = `₹${product.comparePrice}`;
          comparePrice.style.display = 'inline';
        } else {
          comparePrice.style.display = 'none';
        }
      }

      if (savings) {
        if (product.comparePrice > product.price) {
          const pct = Math.round(((product.comparePrice - product.price) / product.comparePrice) * 100);
          savings.textContent = `Save ${pct}%`;
          savings.style.display = 'inline';
        } else {
          savings.style.display = 'none';
        }
      }

      if (desc) desc.textContent = product.description;

      // Render Highlights
      if (highlightsEl && product.highlights) {
        highlightsEl.innerHTML = product.highlights.map(h => `
          <div class="highlight-item">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
            </svg>
            <span>${h}</span>
          </div>
        `).join('');
      }

      // Render Accordion Details
      if (ingredientsEl) {
        ingredientsEl.textContent = product.ingredients || 'Pure cold-pressed Ayurvedic botanicals and clinically proven bio-actives.';
      }
      if (usageEl) {
        usageEl.textContent = product.howToUse || 'Massage gently onto clean skin or hair in upward circular motions until fully absorbed.';
      }

      // Render Thumbnails
      if (thumbsContainer) {
        thumbsContainer.innerHTML = '';
        product.images.forEach((img, idx) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = `qv-thumb-btn ${idx === 0 ? 'active' : ''}`;
          btn.innerHTML = `<img src="${getAssetUrl(img)}" alt="${product.title} view ${idx + 1}" width="52" height="52">`;
          btn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.setImage(idx);
          });
          thumbsContainer.appendChild(btn);
        });
      }

      // Render Mobile Dots
      if (dotsContainer) {
        dotsContainer.innerHTML = '';
        product.images.forEach((_, idx) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = `qv-dot ${idx === 0 ? 'active' : ''}`;
          dot.setAttribute('aria-label', `Go to image ${idx + 1}`);
          dot.addEventListener('click', (e) => {
            e.stopPropagation();
            this.setImage(idx);
          });
          dotsContainer.appendChild(dot);
        });
      }

      this.updateQtyDisplay();

      const modal = document.getElementById('quick-view-modal');
      if (modal) {
        modal.classList.add('open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
    },

    close: function () {
      const modal = document.getElementById('quick-view-modal');
      if (modal) {
        modal.classList.remove('open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    }
  };

  /* ==========================================================================
     7. MOBILE NAVIGATION DRAWER
     ========================================================================== */
  const MobileNav = {
    init: function () {
      const toggle = document.getElementById('mobile-menu-toggle');
      const close = document.getElementById('mobile-nav-close');
      const overlay = document.getElementById('mobile-nav-overlay');
      const drawer = document.getElementById('mobile-nav-drawer');

      if (!drawer) return;

      if (toggle) {
        toggle.addEventListener('click', () => {
          drawer.classList.add('open');
          drawer.setAttribute('aria-hidden', 'false');
          toggle.setAttribute('aria-expanded', 'true');
          document.body.style.overflow = 'hidden';
        });
      }

      const closeDrawer = () => {
        drawer.classList.remove('open');
        drawer.setAttribute('aria-hidden', 'true');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      };

      if (close) close.addEventListener('click', closeDrawer);
      if (overlay) overlay.addEventListener('click', closeDrawer);

      // Close on link click
      drawer.querySelectorAll('.mobile-nav__link').forEach(link => {
        link.addEventListener('click', () => {
          closeDrawer();
          const filter = link.getAttribute('data-filter');
          if (filter) {
            FilterTabs.setCategory(filter);
          }
        });
      });
    }
  };

  /* ==========================================================================
     7b. LIVE SEARCH (TRANSPARENT TEXT-ONLY INSTANT PRODUCT DOSSIER LAUNCHER)
     ========================================================================== */
  const LiveSearch = {
    init: function () {
      const wrap = document.getElementById('header-search-wrap');
      const toggleBtn = document.getElementById('header-search-toggle');
      const bar = document.getElementById('header-search-bar');
      const input = document.getElementById('header-search-input');
      const closeBtn = document.getElementById('header-search-close');

      if (!wrap || !toggleBtn || !bar || !input) return;

      // Open Search
      toggleBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        bar.classList.add('active');
        wrap.classList.add('search-active');
        input.focus();
      });

      // Close Search
      const closeSearch = () => {
        bar.classList.remove('active');
        wrap.classList.remove('search-active');
        input.value = '';
        this.closeResults();
      };

      if (closeBtn) {
        closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          closeSearch();
        });
      }

      // Live search typing
      input.addEventListener('input', () => {
        const query = input.value.trim().toLowerCase();
        if (!query || query.length < 1) {
          this.closeResults();
          return;
        }
        this.search(query);
      });

      // Close on outside click
      document.addEventListener('click', (e) => {
        if (!wrap.contains(e.target)) {
          closeSearch();
        }
      });

      // Close on Escape
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          closeSearch();
        }
      });
    },

    search: function (query) {
      const resultsContainer = document.getElementById('header-search-results');
      if (!resultsContainer) return;

      const matches = Object.values(MAYGLOW_PRODUCTS).filter(p => {
        return p.title.toLowerCase().includes(query) ||
               (p.subtitle && p.subtitle.toLowerCase().includes(query)) ||
               p.category.toLowerCase().includes(query) ||
               (p.ingredients && p.ingredients.toLowerCase().includes(query)) ||
               p.description.toLowerCase().includes(query);
      });

      resultsContainer.innerHTML = '';

      if (matches.length === 0) {
        resultsContainer.innerHTML = `<div class="search-no-results">No results for "${query}"</div>`;
      } else {
        matches.forEach(product => {
          const item = document.createElement('a');
          item.href = 'javascript:void(0)';
          item.className = 'search-result-item';
          item.setAttribute('data-product-id', product.id);
          item.innerHTML = `<span class="search-result-title">${product.title}</span>`;
          item.addEventListener('click', (e) => {
            e.preventDefault();
            this.closeResults();
            const bar = document.getElementById('header-search-bar');
            const wrap = document.getElementById('header-search-wrap');
            if (bar) bar.classList.remove('active');
            if (wrap) wrap.classList.remove('search-active');
            QuickView.open(product.id);
          });
          resultsContainer.appendChild(item);
        });
      }

      resultsContainer.classList.add('show');
    },

    closeResults: function () {
      const resultsContainer = document.getElementById('header-search-results');
      if (resultsContainer) {
        resultsContainer.classList.remove('show');
        resultsContainer.innerHTML = '';
      }
    }
  };

  /* ==========================================================================
     8. DELIVERY NOTICE MODAL (Online Delivery Coming Soon)
     ========================================================================== */
  const DeliveryNotice = {
    modal: null,
    init: function () {
      this.modal = document.getElementById('delivery-notice-modal');
      document.addEventListener('click', (e) => {
        const target = e.target.closest('[data-action="close-delivery-notice"]');
        if (target) {
          e.preventDefault();
          this.close();
        }
      });
    },
    open: function () {
      if (!this.modal) this.modal = document.getElementById('delivery-notice-modal');
      if (this.modal) {
        this.modal.classList.add('open');
        this.modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
    },
    close: function () {
      if (!this.modal) this.modal = document.getElementById('delivery-notice-modal');
      if (this.modal) {
        this.modal.classList.remove('open');
        this.modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    }
  };

  /* ==========================================================================
     9. GLOBAL INITIALIZATION
     ========================================================================== */
  document.addEventListener('DOMContentLoaded', () => {

    // Subsystems
    Cart.init();
    HeroRotator.init();
    BundlesCarousel.init();
    FilterTabs.init();
    QuickView.init();
    MobileNav.init();
    LiveSearch.init();
    DeliveryNotice.init();

    // 3. Escape key closes any open drawer/modal
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        Cart.close();
        QuickView.close();
        DeliveryNotice.close();
        const drawer = document.getElementById('mobile-nav-drawer');
        if (drawer && drawer.classList.contains('open')) {
          drawer.classList.remove('open');
          document.body.style.overflow = '';
        }
      }
    });
  });

})();
